import React from 'react';
// @ts-ignore
import * as d3 from 'd3';
import styled from 'styled-components';

interface VerticalAxisProps {
  yScale: d3.ScaleLinear<number, number>
}

const VerticalAxisLabel = styled.text`
  fill: white;
  font-family: Mapfre-Light;
  font-size: 1.25rem;
  text-anchor: start;
`;

const VerticalAxis = ({ yScale }: VerticalAxisProps) => {
  const ticks = yScale.nice().ticks();

  return (
    <g>
      { ticks.map((value, i) => (
          <VerticalAxisLabel
            key={`vertical-tick-${i}`}
            style={{
              transform: `translate(0px, ${yScale(value)}px)`,
            }}
            transform={`translate(0 ${yScale(value)})`}
          >
            {value}
          </VerticalAxisLabel>
        ))
      }
    </g>
  );
};

export default VerticalAxis;
